export const CREATE_ADMIN_PPE_REQUEST_HISTORY = "CREATE_ADMIN_PPE_REQUEST_HISTORY";   
export const RETRIEVE_ADMIN_PPE_REQUEST_HISTORY = "RETRIEVE_ADMIN_PPE_REQUEST_HISTORY";
export const RETRIEVESINGLE_ADMIN_PPE_REQUEST_HISTORY = "RETRIEVESINGLE_ADMIN_PPE_REQUEST_HISTORY";
export const UPDATE_ADMIN_PPE_REQUEST_HISTORY = "UPDATE_ADMIN_PPE_REQUEST_HISTORY";   
export const DELETE_ADMIN_PPE_REQUEST_HISTORY = "DELETE_ADMIN_PPE_REQUEST_HISTORY";   
